module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selPage) ? _c('div', {
    staticClass: "mtable-tool-selPage"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.clauses_text) + "：")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selPage.list[_vm.selPage.active]))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.selPage.list), function(item, index) {
    return (_vm.selPage) ? _c('template', {
      class: {
        hide: _vm.selPage.list.length >= 1
      },
      slot: "dropdown"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.emitSelPage(index, item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(item))])])]) : _vm._e()
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51405557","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selPage.vue
// module id = 1112
// module chunks = 1